import conf from '../classes/configController';

const parameters = {
  performance: {
    measureTime: false,
  },
  timing: {
    formsValidationControlTimeout: conf(
      'common.timing.formsValidationControlTimeout',
      1000,
    ),
    keyboardFilterDebounceTime: conf(
      'common.timing.keyboardFilterDebounceTime',
      500,
    ),
    notificationVibrateTime: conf('common.timing.notificationVibrateTime', 200),
  },
};

export default parameters;
